<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><span aria-label="ii" class="page" id="pii" role="doc-pagebreak"></span><span aria-label="iii" class="page" id="piii" role="doc-pagebreak"></span>The Matter of Black Living</h1>
<h1 class="bk1">The Aesthetic Experiment of Racial Data, 1880–1930</h1>
<p class="bkau">Autumn Womack</p>
<h1 class="bk2">•</h1>
<p class="bkpub">The University of Chicago Press    Chicago and London</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-womack-0003.vue?a536f198